"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
var isEmail = function (str) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str);
};
exports.isEmail = isEmail;
//# sourceMappingURL=index.js.map